import jwt_decode, { type JwtPayload } from 'jwt-decode'

/**
 * Decodes the `jti` (JWT ID) claim from an auth token without verifying its signature.
 * Returns null when the token is malformed or its `jti` is absent, empty, or not a string.
 */
export const getJtiFromToken = (token: string): string | null => {
  try {
    const { jti } = jwt_decode<JwtPayload>(token)

    return typeof jti === 'string' && jti ? jti : null
  } catch {
    return null
  }
}
